import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {CalendarDepartComment} from '../../models/calendar/calendardepartcomment';
import {Calendar} from '../../models/calendar/calendar';
const apiUrl = `${environment.apiUrl}/api/info/calendardepartcomment`;

@Injectable({
  providedIn: 'root'
})
export class CalendarDepartCommentService {
  constructor(public httpService: HttpClient) { }
  public add(params: Object): Observable<CalendarDepartComment>
  {
    return this.httpService.post(`${apiUrl}/add`, params).pipe(
      map(data => new CalendarDepartComment().deserialize(data)));

  }
  public getCountByKeyword(id: number, maNam: number, donViId: number)
  {
    return this.httpService.get(`${apiUrl}/getcountbykeyword?id=${id}&yid=${maNam}&uid=${donViId}`).pipe(
      map(data => Number(data)));
  }
  findAllByPaging(id: number, maNam: number, donViId: number,  page: number, size: number): Observable<CalendarDepartComment[]> {
    return this.httpService.get<CalendarDepartComment[]>(`${apiUrl}/getallpaging?id=${id}&yid=${maNam}&uid=${donViId}&page=${page}&size=${size}`)
      .pipe(map(data => data.map(data => new CalendarDepartComment().deserialize(data)))
      );
  }
}
